// extracted by mini-css-extract-plugin
module.exports = {"counter":"styles_counter__V9bHq","btn":"styles_btn__u4SkE","count":"styles_count__bHK5o"};